import React from 'react'

import Sidebar from 'components/Sidebar'
import SidebarClose from 'components/SidebarClose'
import SidebarContent from 'components/SidebarContent'
import SidebarHeadline from 'components/SidebarHeadline'
import BrowserItem from 'components/BrowserItem'
import Columns from 'components/Columns'
import Column from 'components/Column'

export default props => (
  <Sidebar anchor="left" isOpen={props.isOpen}>
    <SidebarClose onClose={props.onClose} />

    <SidebarContent>
      <SidebarHeadline>Browse Elements</SidebarHeadline>

      <Columns compact>
        {props.components.map(component => (
          <Column
            key={component._id}
            compact
            smalL={24}
            medium={12}
          >
            <BrowserItem
              theme={props.theme}
              component={component}
              onClick={() => props.onAddComponent(component)}
            />
          </Column>
        ))}
      </Columns>
    </SidebarContent>
  </Sidebar>
)



// WEBPACK FOOTER //
// ./src/components/ComponentBrowser/index.js